import Moment from 'moment';
import ajaxRequestV2 from "../../../core/gd/api-request/lib/ajax-request-v2";

export default function RequestApp3 (context: any, type: any, endpoint: string, data: any, processSessionResponse=true, autoError=true) {

    if (endpoint.substring(0,1)==='/') endpoint.substr(1);

    // add utcOffset
    if (!data) data={};
    data.zz = Moment().format("ZZ");
    data.sid = gd.sessionId;
    data.cid = gd.companyId;    // cid = CompanyID - it can be empty but usually not


    const headers: any = {};
    // @ts-ignore
    if (gd.auth && gd.auth.authMode === 'token') { // "token" ??? It's old mobile !!!
        headers['SessionMode'] = 'token';
        headers['SessionToken'] = gd.auth.authToken;
    }

    headers['gd-cid'] = gd.companyId // add cid (companyId) to header -> from now header is the best way to add to request

    return ajaxRequestV2({
        'type'          : type,
        'endpoint'      : endpoint,
        'url'           : gdConfig.apiApp3 + endpoint,
        'payload'       : data,
        'context'       : context,
        'headers'       : headers
    }, {
        "autoError"                 : autoError,
        "processSessionResponse"    : processSessionResponse
    })

};
